module.exports = __webpack_public_path__ + "img/35912-096.046eba6e.jpg";